import { TextField } from "@material-ui/core";
import { lighten } from "polished";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  secondary,
  disabled,
  white,
} from "../../../../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  searchContainer: {
    marginBottom: theme.spacing(2),
  },
  searchButton: {
    height: 32,
    backgroundColor: secondary,
    color: white,
    fontWeight: 500,
    borderRadius: "0 16px 16px 0",
    paddingRight: theme.spacing(2),
    textTransform: "none",

    "&:hover": {
      backgroundColor: lighten(0.1, secondary),
    },
  },
  tooltipContainer: {
    marginBottom: theme.spacing(1),

    "& p": {
      width: "calc(100% - 24px)",
    },
  },
  tooltipIcon: {
    color: secondary,
    marginTop: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    fontSize: theme.spacing(2),
  },
  searchIcon: {
    color: white,
    marginLeft: theme.spacing(1),
  },
  downloadButton: {
    color: secondary,
    textTransform: "none",

    "& svg": {
      height: 12,
      marginRight: theme.spacing(1),
      color: secondary,
    },
  },
}));

export const CustomTextField = withStyles({
  root: {
    height: 32,
    minWidth: 440,

    "& label.Mui-focused": {},
    "& .MuiInput-underline:after": {},
    "& .MuiOutlinedInput-root": {
      height: 32,

      padding: 0,
      "& fieldset": {
        borderRadius: "16px 0 0 16px",
        borderWidth: "1px 0 1px 1px",
      },
      "&:hover fieldset": {
        borderColor: disabled,
        borderWidth: "1px 0 1px 1px",
      },
      "&.Mui-focused fieldset": {
        borderColor: disabled,
        borderWidth: "1px 0 1px 1px",
      },
    },
  },
})(TextField);

export default useStyles;
